<div>
  <div class="d-flex justify-content-between align-ite ">
      <button class="header-btn m-2 add-btn" mat-raised-button (click)="cancel()">
          <mat-icon>arrow_back</mat-icon> Back
      </button>
      <button *ngIf="(!isEditable && updateTicketId!=='' || isStaff) && (updateTicketId)"   class="header-btn button-primary btn btn-primary" (click)="editTicket()"> Edit Ticket </button>
  </div>

  <form  *ngIf="isEditable || ( !updateTicketId && !isEditable)" [formGroup]="ticketForm" class="d-flex gap-3 flex-row" style="background-color: #fff; margin-left: .2rem; border-radius: 10px; padding: 10px;" >
      <div class="containerr"  style="width: 60%;" >
        
        <div class="field" *ngIf="((roleName === 'SUPER_ADMIN') && !isStaff) && ((!updateTicketId)? true: (ticket.adminCreated))" >
          <label>User Type<span class="text-danger">*</span></label>
          <mat-form-field appearance="outline" class="w-100">
            <mat-select class="fieldInput" formControlName="userType" placeholder="Select" (selectionChange)="onUserTypeChange($event.value)" >
              <mat-option [value]="userType" *ngFor="let userType of ['OEM', 'Distributor', 'Customer', 'Other']"> {{ userType }} </mat-option>
            </mat-select>
            <mat-error class="error-message error-msg" *ngIf="!ticketForm.get('userType')?.valid">
              <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> User Type is Required
            </mat-error>
          </mat-form-field>
        </div>

        <div class="field" *ngIf="(roleName === 'SUPER_ADMIN' && !isStaff) && ((!updateTicketId)? true: (ticket.adminCreated))" >
          <label>Raised For<span class="text-danger">*</span></label>
          <mat-form-field appearance="outline" class="w-100">
            <mat-select class="fieldInput" formControlName="raisedFor" placeholder="Select" (selectionChange)="onRaisedForChange($event.value)">
              <mat-option [value]="raisedFor" *ngFor="let raisedFor of dropDowns?.raisedFor"> {{ raisedFor.name }} </mat-option>
            </mat-select>
            <mat-error class="error-message error-msg" *ngIf="!ticketForm.get('raisedFor')?.valid">
              <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Raised For is Required
            </mat-error>
          </mat-form-field>
        </div>

          <div class="field">
              <label>Name<span class="text-danger">*</span></label>
              <mat-form-field appearance="outline" class="w-100">
                  <input matInput formControlName="name" placeholder="Enter Name" [ngStyle]="{ 'opacity': block  ? 0.8 : 1 }" [readonly]="(block)? true: false" />
                  <mat-error class="error-message error-msg" *ngIf="!ticketForm.get('name')?.valid">
                    <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Name is Required
                  </mat-error>
              </mat-form-field>
          </div>

          <div class="field">
              <label>Phone Number</label>
              <mat-form-field appearance="outline" class="w-100">
                  <input matInput formControlName="phoneNumber" autocomplete="off" placeholder="Enter Phone Number" onlyNumbers maxlength="15" [ngStyle]="{ 'opacity': block  ? 0.8 : 1 }" [readonly]="block? true: false"/>
                  <mat-error class="error-message error-msg" *ngIf="!ticketForm.get('phoneNumber')?.valid">
                    <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Phone Number is Required
                  </mat-error>
              </mat-form-field>
          </div>

          <div class="field">
              <label>Registered Email ID<span class="text-danger">*</span></label>
              <mat-form-field appearance="outline" class="input-font  w-100">
                  <input matInput class="emailInput" formControlName="email" placeholder="Registered Email ID" [ngStyle]="{ 'opacity':block  ? 0.8 : 1 }"[readonly]="block? true: false"/>
                  <mat-error class="error-message error-msg" *ngIf="!ticketForm.get('email')?.valid">
                    <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Email is Required
                  </mat-error>
              </mat-form-field>
          </div>

          <div class="field">
              <label>Issue Related<span class="text-danger">*</span></label>
              <mat-form-field appearance="outline" class="input-font  w-100" placeholder="Select Issue Related" [ngStyle]="{ 'opacity': block ? 0.8 : 1 }">
                  <mat-select class="fieldInput" formControlName="issueRelated" placeholder="Select">
                      <mat-option *ngFor="let issue of dropDowns?.issueRelated" [value]="issue" [disabled]="block? true: false" >{{ issue }}</mat-option>
                  </mat-select>
                  <mat-error class="error-message error-msg" *ngIf="!ticketForm.get('issueRelated')?.valid">
                    <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Issue Related is Required
                  </mat-error>
              </mat-form-field>
          </div>

          <div class="field">
              <label>Subject<span class="text-danger">*</span></label>
              <mat-form-field appearance="outline" class="w-100">
                  <input matInput formControlName="subject" placeholder="Enter Subject" [ngStyle]="{ 'opacity':block ? 0.8 : 1 }" [readonly]="block? true:  false"/>
                  <mat-error class="error-message error-msg" *ngIf="!ticketForm.get('subject')?.valid">
                    <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Subject is Required
                  </mat-error>
              </mat-form-field>
          </div>

          <div class="field" [ngStyle]="{ 'opacity':block ? 0.8 : 1 }">
              <label>Description</label>
              <angular-editor class="descriptionInput" formControlName="description" [config]="config" placeholder="Enter Description" ></angular-editor>
          </div>
          <br>
          <div class="field" [ngStyle]="{ 'opacity': block ? 0.8 : 1 }">
              <label>Attachments</label>
              <div class="file-container d-flex align-items-center justify-content-center " (dragover)="onDragOver($event)"
                  (drop)="selectFile($event, true)">
                  <input
                  [readOnly]="isStaff || isSuperAdmin"
                      #uploadAttachments 
                      class="file-input-container"
                      type="file"
                      id="upload"
                      multiple
                      accept=".png,.jpg,.jpeg,.svg"
                      (change)="selectFile($event, false)"
                      style="display: none;">
                  <label style="cursor: pointer;" class="d-flex justify-content-center text align-items-center p-2" for="upload" mat-raised-button>
                      <img style="margin-top:-4px; margin-right: 1px;" alt="" src="./../../assets/images/icons/drag-icon.svg" *ngIf="!selectedFile">
                      <span  *ngIf="!selectedFile" style="color:#0D87C8; padding: 10px;">Drag files here to upload (or) <span style="text-decoration: underline;"> Select Files</span></span></label>
                      <span class="drag-drop-text2 d-flex g-2" *ngIf="imageURL.length > 0">
                   <div>
                    <div class="upload-file" *ngFor="let uploadFile of imageURL; let i = index;" style="margin-top: 10px;">
                      <span *ngIf="uploadFile" class="file-info attach_file_info" style="border-radius: 5px;">
                        {{ uploadFile }}
                        <span class="remove-file" (click)="removeAttachedFile(i)">
                          <img src="assets/images/cancel.svg" alt="" height="18px" width="20px">
                        </span>
                      </span>
                    </div>
                      <div class="add-img" *ngIf="ticketForm.get('attachments')?.value?.length > 0">
                        <img class="edit-profile mx-1" (click)="triggerAttachmentsInputClick()" src="../../assets/images/add.svg" alt="Edit Profile" />
                        <span class="text1">Add</span>
                      </div>
                   </div>
                      </span>
              </div>
          </div>
          <br>

          <div *ngIf="roleName === 'SUPER_ADMIN'" class="field">
              <label>Update Status<span class="text-danger">*</span></label>
              <mat-form-field appearance="outline" class="w-100">
                  <mat-select class="fieldInput" formControlName="ticketStatus" placeholder="Select">
                      <mat-option [value]="status" *ngFor="let status of ticketStatusDropDown"> {{ status }} </mat-option>
                  </mat-select>
                  <mat-error class="error-message error-msg" *ngIf="!ticketForm.get('ticketStatus')?.valid">
                      <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Update Status is Required
                  </mat-error>
              </mat-form-field>
          </div>

          <div *ngIf="roleName === 'SUPER_ADMIN'" class="field">
              <label>Priority level</label>
              <mat-form-field appearance="outline" class="w-100" [ngStyle]="{ 'opacity': isStaff && updateTicketId  ? 0.8 : 1 }">
                  <mat-select class="fieldInput" formControlName="priorityLevel" placeholder="Select">
                      <mat-option [value]="priority" *ngFor="let priority of dropDowns.priorityLevel" [disabled]="(updateTicketId && isStaff)? true: false"> {{ priority }} </mat-option>
                  </mat-select>
                  <!-- <mat-error class="error-message error-msg" *ngIf="!ticketForm.get('priorityLevel')?.valid">
                      <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Priority Level is Required
                  </mat-error> -->
              </mat-form-field>
          </div>

          <div *ngIf="roleName === 'SUPER_ADMIN'" class="field">
              <label>Assign To<span class="text-danger">*</span></label>
              <mat-form-field appearance="outline" class="w-100" [ngStyle]="{ 'opacity': isStaff && updateTicketId  ? 0.8 : 1 }">
                  <mat-select class="fieldInput" formControlName="assignedTo" placeholder="Select">
                      <mat-option [value]="assign.id" *ngFor="let assign of dropDowns.assignTo" [disabled]="(updateTicketId && isStaff)? true: false"> {{ assign.name }} </mat-option>
                  </mat-select>
                  <mat-error class="error-message error-msg" *ngIf="!ticketForm.get('assignedTo')?.valid">
                      <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Assign To is Required
                  </mat-error>
              </mat-form-field>
          </div>
          <div class="submit" >
              <button class="button-inverse btn btn-primary" type="button" (click)="cancel()">Cancel</button>
              <button class="button-primary btn btn-primary" type="submit" (click)="saveForm()"> {{ ('Submit Ticket') }}  </button>
          </div>
      </div>
      <div class="d-flex" style="padding-top: 10px; max-height: 600px;">
          <img width="400px" src="../../assets/images/support-ticket-img.jpg" alt="image static">
      </div>
  </form>

  <div class="s" style="background-color: #fff; margin-left: .2rem; margin-top: 1rem; border-radius: 10px; padding: 10px;" *ngIf="updateTicketId && !isEditable">
    <div class="col-12" style="background-color: #fff; margin-left: .2rem; border-radius: 10px; padding: 10px;">
      <div class="row">
        <h2 class="page-heading p-2">Ticket Number : {{this.ticket?.ticketSequenceId}}</h2>
        <!-- First Column -->
        <div class="col-md-6" style="padding: 5px;">
          <div style="display: flex; padding: 5px 0;">
            <label style="display: flex; font-weight: bold; min-width: 150px; text-align: right; padding-right: 5px;">Submitted By:</label>
            <span>{{ ticket?.name }}</span>
          </div>
          <div style="display: flex; padding: 5px 0;">
            <label style="display: flex; font-weight: bold; min-width: 150px; text-align: right; padding-right: 5px;">Phone Number:</label>
            <span>{{ ticket?.phoneNumber }}</span>
          </div>
          <div style="display: flex; padding: 5px 0;">
            <label style="display: flex; font-weight: bold; min-width: 150px; text-align: right; padding-right: 5px;">Email:</label>
            <span>{{ ticket?.email }}</span>
          </div>
          <div style="display: flex; padding: 5px 0;">
            <label style="display: flex; font-weight: bold; min-width: 150px; text-align: right; padding-right: 5px;">Issue Related:</label>
            <span>{{ ticket?.issueRelated }}</span>
          </div>
          <div style="display: flex; padding: 5px 0;">
            <label style="display: flex; font-weight: bold; min-width: 150px; text-align: right; padding-right: 5px;">Subject:</label>
            <span>{{ ticket?.subject }}</span>
          </div>
        </div>

        <!-- Second Column -->
        <div class="col-md-6" style="padding: 5px;">
          <div style="display: flex; padding: 5px 0;">
            <label style="display: flex; font-weight: bold; min-width: 150px; text-align: right; padding-right: 5px;">Status:</label>
            <span>{{ ticket?.ticketStatus }}</span>
          </div>
          <div style="display: flex; padding: 5px 0;">
            <label style="display: flex; font-weight: bold; min-width: 150px; text-align: right; padding-right: 5px;">Priority:</label>
            <span>{{ ticket?.priorityLevel || 'Not Assigned' }}</span>
          </div>
          <div style="display: flex; padding: 5px 0;">
            <label style="display: flex; font-weight: bold; min-width: 150px; text-align: right; padding-right: 5px;">Assigned To:</label>
            <span>{{ getAssignedToName(ticket?.assignedTo) || 'Not Assigned' }}</span>
          </div>
          <div style="display: flex; padding: 5px 0;">
            <label style="display: flex; font-weight: bold; min-width: 150px; text-align: right; padding-right: 5px;">Created By:</label>
            <span>{{ userDetailsById?.userName }}</span>
          </div>
          <div style="display: flex; padding: 5px 0;">
            <label style="display: flex; font-weight: bold; min-width: 150px; text-align: right; padding-right: 5px;">Created On:</label>
            <span>{{ ticket?.createdOn | date: 'shortDate' }}</span>
          </div>
        </div>
      </div>

      <!-- Description -->
      <div style="display: flex; padding: 5px 0; margin-left: -8px;">
        <label style="display: flex; font-weight: bold; min-width: 150px; text-align: right; padding-right: 5px;">Description:</label>
        <span [innerHTML]="ticket?.description"></span>
      </div>

      <!-- Attachments -->
      <div style="display: flex; padding: 5px 0; margin-left: -8px;">
        <label style="display: flex; font-weight: bold; min-width: 150px; text-align: right; padding-right: 5px;">Attachments:</label>
        <span>
          <ul style="padding-left: 18px;">
            <li *ngFor="let attachment of ticket?.attachments">
             <a href="{{attachment}}" target="_blank">
              {{ attachment.split('/').pop() }}
          </a>
            </li>
          </ul>
        </span>
      </div>
    </div>
  
  </div>       

  <div  *ngIf="updateTicketId" class="d-flex gap-3 flex-column " style="background-color: #fff; margin-left: .2rem; margin-top: 1rem; border-radius: 10px; padding: 10px;">
      <label>Comments</label>

      <div *ngFor="let comment of commentsFormList; let idx = index" class="d-flex flex-column gap-2 ">
          <div class="d-flex flex-column gap-1">
              <span> 
                  <img src="../../assets/images/Ellipse 2 (1).svg" alt="profile pic"> 
                  {{comment.userName}}
                  <span style="color: #978888;" > {{ comment.createdOn | date: 'MM/dd/yyyy' }} </span>
                  <span *ngIf="viewcomment">
                  <img *ngIf="comment.createdBy === userId" src="../../assets/images/edit.svg" (click)="editComment(comment)" style="cursor: pointer;" />   
                  <img *ngIf="comment.createdBy === userId" src="../../assets/images/icons/delete-icon.svg" (click)="deleteComment(comment)" style="cursor: pointer;" />  
                </span>
              </span>
              <span style="padding-left: 35px;" [innerHTML]="comment.commentMessage"> </span>  <span style="cursor: pointer;" > </span> 
              <span style="padding-left: 35px;" class="commentAttachments" *ngFor="let attachment of comment.commentAttachments">
                  <a href="{{attachment}}" target="_blank">
                  {{ attachment.split('/').pop() }}
              </a>
              </span>
          </div>
      </div>

      <form [formGroup]="commentsForm" *ngIf="addComment"  >
          <div class="containerr" style="width: 60%;" >
              <div class="field">
                  <angular-editor formControlName="commentMessage" [config]="configComment" placeholder="Enter comment here" ></angular-editor>
                  <div class="input-group chat-field w-100" [class.active]="attachedFiles.length !== 0" style="position: relative;" (dragover)="onDragOver($event)" (drop)="uploadPhoto($event, true)">
                      
                      <!-- comment attachments -->
                      <div class="chat-options-container">

                          <div class="chat-options">
                              <span class="attach_btn" style="cursor: pointer;">
                                <br>
                                <button class="header-btn button-primary btn btn-primary" (click)="fileInput.click()">Add Attachment</button>
                                <input type="file" #fileInput (change)="uploadPhoto($event, false)" style="display: none;" multiple />
                              </span>&nbsp;&nbsp;
                              <div class="input-group-append send">
    
                              </div>
                            </div>
                        <div class="" *ngIf="attachedFiles.length !== 0">
                          <div class="upload-file" *ngFor="let uploadFile of attachedFiles; let i = index;">
                            <span *ngIf="uploadFile" class="file-info attach_file_info" style="border-radius: 5px; margin-top: 10px;">
                              {{ uploadFile }}
                              <span class="remove-file" (click)="removeUploadedFile(i)">
                                <img src="assets/images/cancel.svg" alt="" height="18px" width="20px">
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
              </div>
          </div>
          <div class="submit d-flex align-items-center gap-2 p-0 justify-content-start" *ngIf="addComment" style="padding-top: 20px !important;" >
              <button class="d-flex more" type="button" style="border: 1px solid #0D87C8;" (click)="addCommentToList()">
                  <span class="deltext">Add</span>
              </button>
              <button class="d-flex more" type="button" style="border: 1px solid #0D87C8;" (click)="cancelComment()">
                  <span class="deltext">Cancel</span>
              </button>
          </div>
      </form>

      <button style="width: fit-content;" *ngIf="!addComment && viewcomment" class="d-flex more mb-3" type="button" (click)="addComments()">
          <mat-icon>add</mat-icon>
          <span class="deltext">Add Comment</span>
      </button>
  </div>

  </div>